import RatingPage from '@components/RatingPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'stress'

const RATING_TO_ANSWER = {
  '1': 'Rarely',
  '2': 'Occasionally',
  '3': 'Sometimes',
  '4': 'Often',
  '5': 'Daily',
}

export default function StressPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(RATING_TO_ANSWER).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('rating') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you feel stressed sometimes?',
      answer_key: value,
      answer: RATING_TO_ANSWER[value as keyof typeof RATING_TO_ANSWER],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <RatingPage
      title="pages.onboarding.stress.heading"
      minSubtitle="pages.onboarding.stress.options.rarely"
      maxSubtitle="pages.onboarding.stress.options.daily"
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
